// extracted by mini-css-extract-plugin
export default {"zippingThumb":"X5tIvB"};